var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClCafe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "9.525mm",
    height: "7.7611mm",
    viewBox: "0 0 27 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3775,11.9554l-2.7005,2.4781-.4061-.4425,2.7006-2.478.406.4424Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2988,11.9554l-2.7005,2.4781-.4061-.4425,2.7006-2.478.406.4424Z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6261,6.304c.4719.719,1.2852,1.1939,2.2095,1.1939.6848,0,1.3086-.2607,1.7779-.6881v15.1963H.9629V6.8099c.4692.4274,1.0931.688,1.7778.688.9243,0,1.7376-.4749,2.2095-1.1939.4719.719,1.2852,1.1939,2.2095,1.1939.9243,0,1.7376-.4749,2.2095-1.1939.4719.719,1.2851,1.1939,2.2094,1.1939.9244,0,1.7376-.4749,2.2095-1.1939.4719.719,1.2852,1.1939,2.2095,1.1939.9243,0,1.7376-.4749,2.2095-1.1939.4719.719,1.2852,1.1939,2.2095,1.1939.9243,0,1.7376-.4749,2.2095-1.1939ZM3.792,21.2849h6.6381v-11.4572H3.792v11.4572ZM12.8202,16.4393h10.9698v-6.5791h-10.9698v6.5791Z",
    fill: "#fff",
    fillRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5186,4.8568c0,.9819-.7959,1.7779-1.7778,1.7779-.0723,0-.1436-.0045-.2136-.0129-.0032-.0003-.0063-.0005-.0095-.0009l-.0034-.0005c-.8565-.1089-1.5226-.8271-1.5504-1.7063.0001.0038,0,.0076.0002.0114-.0003-.0076-.0006-.0152-.0008-.0227l-.0005-.0459V.7583h3.5557v4.0986Z",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.9375,4.8568c0,.9394-.7286,1.7084-1.6516,1.7732-.0026.0002-.0052.0004-.0077.0006-.0109.0007-.0219.0013-.0328.0019-.0284.0014-.057.0022-.0857.0022-.9641,0-1.7489-.7675-1.7769-1.7248,0,.0014,0,.0027.0001.0041-.0001-.0038-.0004-.0076-.0005-.0114l-.0006-.0459V.7583h3.5558v4.0986Z",
    fill: "#fff",
    fillRule: "evenodd"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6135,4.8568c0,.9426-.7337,1.7138-1.6612,1.7739.0007,0,.0015,0,.0022-.0001l-.0055.0005c-.0019.0001-.0039.0002-.0059.0002-.0273.0016-.0548.0026-.0824.0029-.0084.0001-.0167.0005-.0251.0005-.0071,0-.0142-.0003-.0212-.0003.007,0,.014.0002.0211.0002-.0361,0-.0719-.0012-.1074-.0033-.0021,0-.0042-.0001-.0063-.0002l-.0057-.0005c.0017.0001.0034.0001.005.0002-.9076-.0577-1.6301-.7962-1.6621-1.7106-.0002-.0059-.0006-.0117-.0007-.0176l-.0004-.0305c0-.0051,0-.0103,0-.0154V.7583h3.5557v4.0986Z",
    fill: "#fff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3565,4.8568c0,.9819-.796,1.7778-1.7779,1.7778-.9639,0-1.7487-.7672-1.7769-1.7243,0-.0025-.0003-.0051-.0004-.0076l-.0002-.0215c-.0001-.0081-.0002-.0163-.0002-.0244V.7583h3.5556v4.0986Z",
    fill: "#fff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7755,4.8568c0,.9819-.796,1.7778-1.7779,1.7778-.964,0-1.7487-.7672-1.7769-1.7243-.0001-.0025-.0003-.0051-.0004-.0076l-.0002-.0215c-.0001-.0081-.0002-.0163-.0002-.0244V.7583h3.5556v4.0986Z",
    fill: "#fff"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1945,4.8568c0,.9819-.796,1.7778-1.7779,1.7778-.9665,0-1.7528-.7712-1.7772-1.7318v.0077c0-.0026,0-.0052-.0001-.0079l-.0005-.0459V.7583h3.5557v4.0986Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClCafe);
export default __webpack_public_path__ + "static/media/cl-cafe.4ab66fb9b1d13389667f004c8c38ec03.svg";
export { ForwardRef as ReactComponent };